import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
// polyfill for older browsers
import 'intersection-observer';
import { withFilteredRoutes } from './hocs/withFilteredRoutes';
import { Miss } from './routes';
import { ProductTypeContextProvider } from '@contexts/ProductTypeContext';
import { routes } from '@infrastructure/routing/routes';

const App = withFilteredRoutes<any>(({ routes: filteredRoutes }) => (
  <ProductTypeContextProvider>
    <Switch>
      <Route
        exact
        path={routes.productSelection}
        render={() => <Redirect to={routes.briefingShortlistFormStep1} />}
      />
      {filteredRoutes.map(({ path: routePath, component, exact = true }) => (
        <Route
          component={component}
          exact={exact}
          key={Array.isArray(routePath) ? routePath.join(',') : routePath}
          path={routePath}
        />
      ))}
      <Miss />
    </Switch>
  </ProductTypeContextProvider>
));

export { App };
